export default __webpack_public_path__ + "static/2010-5-36860eb1181269b1deb2eaa731bb5bb5.jpg";